angular.module('picmonicng').directive('browseScrollTo', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        if (scope.$eval(attrs.browseScrollTo)) {
          setTimeout(function () {
            angular.element('.browse__content').animate(
              {
                scrollTop: element.offset().top - 200 + 'px',
              },
              'fast'
            );
          }, 0);
        }
      },
    };
  },
]);
